import React from 'react';
import ResourceDetailHeader from 'js/components/ResourceDetailHeader/ResourceDetailHeader';
import { updateSchemaSpec } from 'js/actions';
import { Stack } from 'new/elements/Stack';
import Typography from 'new/elements/Typography';
import { ReactComponent as SchemaTemplatesIcon } from 'new/components/icons/fi-rr-layout-fluid.svg';
import SchemaSpecDetailActionsContainer from 'js/components/schemaSpecs/cards/SchemaSpecDetailActionsContainer';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import useAppDispatch from 'js/hooks/useAppDispatch';

interface SchemaDetailHeaderProps {
  readOnly: boolean;
  adminAccess: boolean;
  disableEditing: boolean;
  data: any;
  status: any;
  isEditable: any;
  isDetected: boolean;
  disableEditMessage: any;
  isManaged: any;
  onEditButtonClicked: () => void;
}

const BoxInfo = ResourceDetailHeader.TopContent.BoxInfo;

export const SchemaDetailHeader = (props: SchemaDetailHeaderProps) => {
  const { readOnly, adminAccess, data, isManaged, onEditButtonClicked } = props;
  const dispatch = useAppDispatch();

  if (!data) {
    return null;
  }

  const updateInfo = (id, info) => {
    dispatch(updateSchemaSpec(data.id, info));
  };

  return (
    <ResourceDetailHeader
      readOnly={readOnly}
      adminAccess={adminAccess}
      data={data}
      updateInfo={updateInfo}
    >
      <ResourceDetailHeader.TopContent>
        <Stack direction="row" alignItems="center" justifyContent="space-between" gap="16px">
          <Stack direction="row" alignItems="center" gap="16px">
            <BoxInfo>
              <SchemaTemplatesIcon />
              <Typography variant="body3">Schema Template</Typography>
            </BoxInfo>
            <ChipWithCopy tooltipTitle="Copy Schema Template ID" toCopy={data.id}>
              ID {data.id}
            </ChipWithCopy>
          </Stack>
          <Stack direction="row" alignItems="center" gap="16px">
            <SchemaSpecDetailActionsContainer
              data={data}
              onEditButtonClicked={onEditButtonClicked}
              disableEditing={false}
              disableEditMessage={null}
              readOnly={readOnly}
              isManaged={isManaged}
              hideMenuDetails={true}
            />
          </Stack>
        </Stack>
      </ResourceDetailHeader.TopContent>
    </ResourceDetailHeader>
  );
};
